import { EventsTrainSortColumn } from "@framework/types";

export const sortMatchForDb: Record<string, EventsTrainSortColumn> = {
  status: EventsTrainSortColumn.DataAlarmStatus,
  type: EventsTrainSortColumn.EventType,
  pointName: EventsTrainSortColumn.PointName,
  date: EventsTrainSortColumn.EventLogDate,
  parameter: EventsTrainSortColumn.MeasureType,
  fullName: EventsTrainSortColumn.UserLogin,
  message: EventsTrainSortColumn.DataValue1,
};

export const sortMatchForTable: Record<EventsTrainSortColumn, string> = {
  [EventsTrainSortColumn.DataAlarmStatus]: "status",
  [EventsTrainSortColumn.EventType]: "type",
  [EventsTrainSortColumn.PointName]: "pointName",
  [EventsTrainSortColumn.EventLogDate]: "date",
  [EventsTrainSortColumn.MeasureType]: "parameter",
  [EventsTrainSortColumn.UserLogin]: "fullName",
  [EventsTrainSortColumn.DataValue1]: "message",
};
